const PageNotFound = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-12 bg-gray-50">
      <h1 className="text-8xl font-bold text-gray-800 mb-4">404</h1>
      <h2 className="text-3xl font-semibold text-gray-700 mb-6">Page Not Found</h2>
      <p className="text-lg text-gray-600 max-w-md text-center mb-8 leading-relaxed">
        Ooops! Die Seite, die Sie suchen, scheint sich in die digitale Wildnis verirrt zu haben. Wir bringen Sie zurück
        auf den richtigen Weg.
      </p>
      <button
        onClick={() => (window.location.href = "/")}
        className="px-8 py-3 text-lg font-medium text-white bg-blue-500 rounded-lg hover:bg-blue-600 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      >
        Zurück zur Startseite
      </button>
    </div>
  );
};

export default PageNotFound;
